module.exports = "/fonts/gt-walsheim-thin.ttf";